// extracted by mini-css-extract-plugin
export default {"badge":"ClassificationBadge_badge__sMFNK"};